import React from "react";

function MavTopRisks({ childTopRisks, riskLoading, isError }: any) {
    return !riskLoading && (!childTopRisks || isError) ? null : (
        <div className="row">
            <div className="col-xs">
                <div className={riskLoading ? "box offset-padding mb-0 loading no-bottom-padding" : "box offset-padding mb-0 no-bottom-padding"}>
                    <div className="box-header">
                        <div className="box-title-container no-margin">
                            <div className="box-title-icon">
                                <em className="las la-flag"></em>
                            </div>
                            <div className="box-title-text">
                                <h2 className="box-title">Top Risks</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mav-risk-list">
                    {!riskLoading &&
                        childTopRisks &&
                        childTopRisks.length > 0 &&
                        childTopRisks.map((childDetail: any, index: number) => {
                            return (
                                <div
                                    role="grid"
                                    key={index}
                                    className={index === childTopRisks.length - 1 ? "data-grid row-height-sm" : "data-grid has-lines row-height-sm"}
                                >
                                    <div role="row" className={index === 0 ? "row flex-center padding-vertical-s" : "data-row row flex-center"}>
                                        <div role="gridcell" className="col-xs-12 col-sm-6 col-no-gutter">
                                            <div className="data-label f-14 top-risk-label">{childDetail.risk}</div>
                                        </div>
                                        <div role="gridcell" className="col-xs-12 col-sm-6 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-9 col-md-10 input-card">
                                                    <div className="data-value" style={{ display: "flex", alignItems: "center" }}>
                                                        <div className="f-14 fw-600">{childDetail.total}</div>
                                                        <div className="w-100">
                                                            <div id="onboard-progress" className="onboard-progress-track" style={{ marginLeft: "5%" }}>
                                                                <div
                                                                    className="onboard-progress-value"
                                                                    style={{
                                                                        width: `${childDetail.percentage}%`,
                                                                        backgroundColor: "#0A7087",
                                                                    }}
                                                                ></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xs-3 col-md-2 flex-end">
                                                    <div className="data-value f-14">
                                                        <span>{childDetail.percentage}%</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
        </div>
    );
}

export default MavTopRisks;
